import { ActivitySectorTag } from 'app/components/profile/activity-sector-tag';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { type Profile } from 'app/network/profile';
import { useTranslation } from 'react-i18next';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconVectorBezierCircle } from '@tabler/icons-react-native';
import { theme } from './shared';

export function ProfileActivitySectors({
  enabled,
  sectors,
}: {
  enabled: boolean;
  sectors: Profile['activitySectors'];
}) {
  const { t } = useTranslation();
  if (!enabled || !sectors?.length) return null;
  return (
    <Row
      flexWrap="wrap"
      style={{ columnGap: theme.spacing['spacing.general.x1'], rowGap: theme.spacing['spacing.general.x1'] }}
    >
      <Row alignItems="center" gap="spacing.general.x2">
        <IconVectorBezierCircle strokeWidth={ICON_STROKE_WIDTH} size={18} color="#999999" />
        <Text color="text.primary" variant="bodyBase">
          {t('sectorActivity', { ns: 'neighbour-profile' })}
        </Text>
      </Row>
      {sectors.map((sector) => (
        <ActivitySectorTag key={sector.id} label={sector.name} />
      ))}
    </Row>
  );
}
